<template>
  <div>

    <pageTable ref="snTable"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/company/companySn"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="add_time">
          <DatePicker v-model="searchData.add_time" type="datetimerange" placeholder="消费时间" style="width: 320px"></DatePicker>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <Button type="info" @click="download">导出</Button>
      </template>

    </pageTable>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import XLSX from 'xlsx'

  export default {
    name: "companySn",
    components:{pageTable},
    props:{
      companyId:{
        type:Number,
        default: 0
      }
    },
    data() {
      return {
        searchData: {
          company_id:this.companyId,
          add_time:''
        },
        tableColumn: [
          {title: 'ID',key: 'id',align: "center"},
          {title: '发生数量',key: 'amount',align: "center"},
          {title: '消费前数量',key: 'before_amount',align: "center"},
          {title: '消费后数量',key: 'after_amount',align: "center"},
          {title: '时间',key: 'add_time',align: "center"},
          {title: 'IP',key: 'add_ip',align: "center"},
          {title: '类型',key: 'type_name',align: "center"},
          {title: '操作人',key: 'operator_name',align: "center"},
          {title: '备注',key: 'remark',align: "center"},
        ],
        tableData: [],

      }
    },
    methods: {
      download(){
        this.$commonFun.postProxy('admin/company/exportCompanySn',this.searchData).then(res=>{
          this.$commonFun.dealApiResult(res,()=>{
            let worksheet = XLSX.utils.aoa_to_sheet(res.data)
            let workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
            XLSX.writeFile(workbook,`车队流水记录.xlsx`)
          })
        })
      },
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>
